import { render, staticRenderFns } from "./showRobCarte.vue?vue&type=template&id=14487459&scoped=true"
import script from "./showRobCarte.vue?vue&type=script&lang=js"
export * from "./showRobCarte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14487459",
  null
  
)

export default component.exports